import HomeHeader from '../../components/home/header/HomeHeader'
import LoginContainer from '../../components/login/LoginContainerComponent'
import './LoginPage.css'

const LoginPage = () => {
  return (
    <div>
      <div className='header-container'>
        <HomeHeader isHeaderLeft={false} showLoginButton={false} showSignupButton={false}/>
      </div>
      <div className="login-background">
        <LoginContainer />
      </div>
    </div>
  );
}

export default LoginPage;